import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/v2/avatar";
import { cn } from "@/lib/utils/cn";

type CaptainAvatarProps = {
  size?: "sm" | "lg";
  isActive?: boolean;
  className?: string;
};

export function CaptainAvatar({ size = "sm", isActive, className }: CaptainAvatarProps) {
  const sizeClass = size === "lg" ? "size-20" : "size-8";
  const breatheClass = isActive ? "animate-[captain-breathe_2s_ease-in-out_infinite]" : "";

  return (
    <Avatar className={cn(sizeClass, "bg-muted", breatheClass, className)}>
      <AvatarImage src="/assets/captain/avatar.png" alt="Captain" />
      <AvatarFallback className="bg-muted text-xs">AI</AvatarFallback>
    </Avatar>
  );
}
